import ReactGA from 'react-ga'

const ID = 'UA-112610371-2'

ReactGA.initialize(ID, {
  // debug: true,
})

const pagesToSkip = ['/', '/analytics']

const sendPageToAnalytics = (location) => {
  const page = location.pathname
  if (pagesToSkip.includes(page)) return
  ReactGA.pageview(page)
}

const startAnalytics = (history) => {
  sendPageToAnalytics(history.location)
  history.listen(sendPageToAnalytics)
}

export default startAnalytics
